import React, {Component} from 'react';
import configs from '../../Config.json';
import { Accordion,Spinner,Card,Button ,Row,Col,Image, Table} from 'react-bootstrap';
import LogoBodas from '../../Resources/Images/LogoBodas.jpg';
import LogoRegalos from '../../Resources/Images/LogoRegalos.jpg';
import bodaImg1 from '../../Resources/Images/imagenBodas1.jpg';
import bodaImg2 from '../../Resources/Images/imagenBodas1.jpg';
import regalosImg1 from '../../Resources/Images/imagenRegalos1.jpg';
import regalosImg2 from '../../Resources/Images/imagenRegalos1.jpg';
import {Link} from "react-router-dom";
import Search from "../HeaderComponents/Search";

class ListarEventos extends Component {
    constructor(props) {
        super(props);
        this.state = {
            varPais: this.props.varPais,
            idPais: this.props.idPais,
            urlPais: this.props.urlPais,
            eventType : this.props.eventType,
            desc : this.props.desc,
            eventos: [],
            setdatos: [],
            mesAño: [],
            busqueda: '',
            eventosOriginal: [],
            searching: false,
            isLoaded: false,
            showing: true,
            handleImage: true
        };
        this.filtrarMesAño = this.filtrarMesAño.bind(this);
        this.makeBottom = this.makeBottom.bind(this);
        //Handle images
        this.handleImage = this.handleImage.bind(this);
    }

    abortController = new AbortController();
    
    async  componentDidMount() {
      let idPais = this.state.idPais !== undefined ? this.state.idPais : this.props.location.state.idPais
      const response = await fetch(configs[0].host+'/eventsClub/getEventList?countryId='+ idPais +'&eventTypeId='+ this.state.eventType +'&eventId=-1&eventName=', {signal: this.abortController.signal, method: 'GET', headers:{"token": process.env.REACT_APP_API_TOK} })
      const json = await response.json();
      this.setState({eventos: json.events, eventosOriginal: json.events, isLoaded: true}) 
    }

    componentWillUnmount() {
      this.abortController.abort();
    }

    handleSearch = async (e) => {
      e.persist();
      await this.setState({ busqueda: e.target.value, searching: true});
      if(e.target.value === ""){
        this.setState({ searching: false});
      }
      this.filtroDeElementos();

    }

    filtroDeElementos = () => {

      var data = this.state.eventosOriginal;
      var search = data.filter(item => {
        if (item.eventid.toString().includes(this.state.busqueda) || 
        item.name.toLowerCase().includes(this.state.busqueda) || 
        item.name.includes(this.state.busqueda) || 
        item.name.toLowerCase().includes(this.state.busqueda.toLowerCase()) ||
        item.name.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(this.state.busqueda)
        ) {
          return item;
        }else{
          return null
        }
      })
      this.setState({eventos: search})
    }
    handleImage() {
      this.setState( prevState => (
        {
          handleImage: !prevState.handleImage
        }
      ));
    }

    resizeRegisterBtn = () => {
      var h = document.getElementById("main-accordion").style.height
      document.getElementById("btn-container").style.height = h;
    }

    render() {
        let meses =["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"];
        //Retorna meses y años sin repetirse de todas las fechas que se han ingresado.
        let mesAño = this.filtrarMesAño(this.state.eventos);
        let eventos = this.state.eventos;
        //Cuando el input del search cambie a onchange sera true
        let searching = this.state.searching;
        let tipoEvento = this.state.eventType;
        var country = this.state.idPais;
        let varPais = this.state.varPais;
        let theKey = this.state.keyTok;
        let urlPais = this.state.urlPais;
        let handleImage = this.state.handleImage;
        const handleImageFunction = () => this.handleImage();

        return (
          
          <div className="clubes--row">
          <Row className="clubes--mobile-style pt-3 pb-3 clubes--sticky-top">
              <div className="mx-auto">
                <Search busqueda={this.state.busqueda}
                handleSearch={this.handleSearch}></Search>
              </div>
          </Row>
          <div className="container">
            <Row className="mb-3 mt-3">
              <div className="mx-auto">
                {
                  (tipoEvento >= 4) 
                  ? <Image src={LogoRegalos} fluid className={(this.state.searching) ? "clubes--logos" : null  } /> 
                  : <Image src={LogoBodas} fluid className={(this.state.searching) ? "clubes--logos" : null } />
                }
              </div>
            </Row>
            <Row id="acordion-main">
              {/** Hay que validar la imagen */}
              <Col sm={6}>
                <Col>
                      {
                        this.state.eventType >= 4 
                        ?
                          handleImage ?  <Image id="regalosLista1" src={regalosImg1} fluid/> : <Image id="regalosLista2" src={regalosImg2} fluid/>
                        : 
                          handleImage ?  <Image id="bodasLista1" src={bodaImg1} fluid/> : <Image id="bodasLista2" src={bodaImg2} fluid/>
                      }
                </Col>
                <Col className="d-none d-lg-flex d-md-flex justify-content-center align-items-center pb-2 pt-2" style={{height:  "calc(100% - 384px)"}}>
                  {
                    this.state.eventType >= 4 ? this.makeBottom('Regalos',this.state.varPais) : this.makeBottom('Bodas',this.state.varPais)
                  }
                </Col>
                    
                    
              </Col>
              <Col sm={6}>
                    <h5 className="text-center" style={{color:"#545454"}}>
                      Selecciona el mes del evento
                    </h5>
                    {mesAño.map(
                      function(mes) {
                        return(
                          <div key={`${meses[mes.mes]}-${mes.año}`}>
                            {/** Si es true abrira todos los acordiones */}
                            <Accordion { ...(searching ? { activeKey: `${meses[mes.mes]}-${mes.año}`} : {} )} >
                              
                            <Card.Header className="clubes--accordion-header">
                              <Accordion.Toggle as={Button} className="clubes--accordion-button" variant="link" eventKey={`${meses[mes.mes]}-${mes.año}`} onClick={handleImageFunction}>
                                {meses[mes.mes] + ' - ' + mes.año}
                              </Accordion.Toggle>
                            </Card.Header>
                            {
                              <Accordion.Collapse eventKey={`${meses[mes.mes]}-${mes.año}`}>
                                <Card.Body>
                                  <Table borderless hover size="sm">
                                    <tbody>
                              {
                                eventos.map( 
                                  
                                  function(evento){
                                    const f = new Date(evento.eventdate);
                                    if (f.getMonth() === mes.mes && f.getUTCFullYear() === mes.año) {
                                      
                                      return (
                                          
                                          <tr key={evento.eventid} className="text-center clubes--table-tr">
                                            <td className="clubes--td-idevento pt-4 clubes--table-name">{`${evento.eventid}`}</td>
                                              <td className="clubes--td-name pt-4">
                                                
                                              
                                              <Link className="clubes--table-link" key={evento.eventid} to={
                                                                {
                                                                    pathname: 'detalle-evento/'+evento.eventid,
                                                                    state: {
                                                                        eventoName: evento.name,
                                                                        eventoFecha: evento.eventdate,
                                                                        eventoTipo: evento.evtTypedescription,
                                                                        eventoId: evento.eventid,
                                                                        idPais: country,
                                                                        urlPais: urlPais,
                                                                        varPais: varPais,
                                                                        keyTok: theKey,
                                                                        eventTypeId: evento.eventtypeid,
                                                                        totalItems: evento.items
                                                                    }
                                                            }}>
                                                                <p className="clubes--table-name">
                                                                    {`${evento.name}`}
                                                                </p>
                                                            </Link>  
                                              
                                              </td>
                                            <td className="clubes--td-descevento pt-4 clubes--table-name">{`${evento.evtTypedescription}`}</td>
                                          </tr>
                                          
                                      )
                                    }else{
                                      return null;
                                    }               
              
                                  }
                    
                                )
                              }
                                  </tbody>
                                </Table>
                              </Card.Body>
                              </Accordion.Collapse>
                            }
                            </Accordion>
                          </div>
                        )
                      }
                    )
                    
                }
                <div>
                  { 
                  this.state.isLoaded !== true ? 
                  <Row className="d-flex justify-content-center align-items-center flex-column">
                    <Spinner  animation="border" role="status" variant="center">
                      <span className="sr-only">Loading...</span>
                    </Spinner>
                    <p>Agradecemos su espera...</p>
                  </Row>
                  : ''
                  }
                </div>
              </Col>
            </Row>
            <hr></hr>
            
            <Row className="d-flex justify-content-center" > 
                  
            <div className="col-12 d-block d-lg-none d-md-none justify-content-end">
                {
                  this.state.eventType >= 4 ? this.makeBottom('Regalos',this.state.varPais) : this.makeBottom('Bodas',this.state.varPais)
                }
              </div>
            
              <Col xs={12} sm={12} lg={12} className="clubes--col mt-3 justify-content-end">
                <Link className="btnsNav float-right bold d-flex justify-content-center align-item-center" to={this.state.varPais} >Regresar a búsquedas <div className="clubes--back-icon"></div></Link> 
              </Col>
              
            </Row>

          {/** Fin */}
          </div>
        </div>
        );
    }
    filtrarMesAño(eventos){
      let arrayMesAño = [];
      //De todos los eventos obtenemos todos los meses y años 
      eventos.map(
        function(evento){
          const fechaEvento = new Date(evento.eventdate);
          return arrayMesAño.push( {mes: fechaEvento.getMonth(),año: fechaEvento.getFullYear()} )
        }
      );
      
      var hash = {};
      //De el areglo antes encontrado obtenemos mes y año sin repetirse
      arrayMesAño = arrayMesAño.filter(function(item){
        var exist = !hash[item.mes];
        hash[item.mes] = true;
        return exist;
      });
      return arrayMesAño;
    }
    makeBottom(eventType, pais) {
      var urlsForm = {}
      if(eventType === "Regalos" ) {
        urlsForm.SV = "https://forms.gle/2LD82hdsFms6B6227";
        urlsForm.GT = "https://forms.gle/VmNQ1bacamjNxGzm8";
        urlsForm.CR = "https://forms.gle/xhjeb9rxzy97rrqA8";
        urlsForm.NI = "https://forms.gle/cZE7gUqTAtjkWAnX7";
      }else {
        urlsForm.SV = "https://forms.gle/T2GZvNqwt941j9ENA";
        urlsForm.GT = "https://forms.gle/o9Ec8RH6aYk4FEUr5";
        urlsForm.CR = "https://forms.gle/HpZZKygeoCxa9n3JA";
        urlsForm.NI = "https://forms.gle/29uo43KEz6Ri3c1K7";
      }
      var valor = pais.replace("/", "").replace("/", "");
      
      return( 
      <Col className="clubes--col">
        <a style={{ fontFamily: 'ClanOT-Medium', color:'#000000', textDecoration: 'none' }} className="btnsNav2 float-right bold d-flex justify-content-center align-item-center" href={urlsForm.[valor]} >Regístrate aquí en Nuestro Club de {eventType}</a> 
      </Col>
      )
    }
}
export default ListarEventos;